export const IMAGE_PREVIEW_MODAL_SIZE = {
  width: 1200,
  height: 800,
};
